var CopilotMode = /* @__PURE__ */ ((CopilotMode2) => {
  CopilotMode2["autoBuild"] = "auto_build";
  CopilotMode2["askAsYouBuild"] = "ask_as_you_build";
  return CopilotMode2;
})(CopilotMode || {});

var FeedbackValue = /* @__PURE__ */ ((FeedbackValue2) => {
  FeedbackValue2["GOOD"] = "Good";
  FeedbackValue2["BAD"] = "Bad";
  return FeedbackValue2;
})(FeedbackValue || {});
var FeedbackType = /* @__PURE__ */ ((FeedbackType2) => {
  FeedbackType2["THUMBS_UP"] = "thumbsUp";
  FeedbackType2["THUMBS_DOWN"] = "thumbsDown";
  return FeedbackType2;
})(FeedbackType || {});
var FeedbackSentiment = /* @__PURE__ */ ((FeedbackSentiment2) => {
  FeedbackSentiment2["POSITIVE"] = "positive";
  FeedbackSentiment2["NEGATIVE"] = "negative";
  return FeedbackSentiment2;
})(FeedbackSentiment || {});

export { CopilotMode as C, FeedbackValue as F, FeedbackType as a, FeedbackSentiment as b };
//# sourceMappingURL=types-DJw4fOmh.mjs.map
